export default __webpack_public_path__ + "c956e476610385fb0eaf98758ed1f850.png";